import { graphql } from 'gatsby';
import matchSorter from 'match-sorter';
import React from 'react';

const getExhibitorAddress = item =>
  `${item.countryName || ''} ${item.region || ''} ${item.city || ''}`.trim();

export default function useExhbitorSearch(items, query) {
  return React.useMemo(
    () =>
      matchSorter(items, query, {
        keys: ['name', getExhibitorAddress, 'stand.titleWithPrefix'],
        threshold: matchSorter.rankings.ACRONYM,
      }),
    [items, query]
  );
}

export const fragment = graphql`
  fragment Search_Exhibitor on Exhibitor {
    __typename
    name
    countryName: country(full: true)
    region
    city
    stand {
      titleWithPrefix: title(prefix: "Stand ")
    }
  }
`;
